export default __webpack_public_path__ + "static/media/arrow_left.494d8ce4.svg";